import { object, SchemaOf, string, } from 'yup';

import { BulkAssignPurchaseOrderVariables } from '@/graphql/contracts/_generated_/bulkAssignPurchaseOrder.mutation';
import { REQUIRED_FIELD } from '@/config/text.const';

export type Fields = Pick<BulkAssignPurchaseOrderVariables, | 'purchaseOrderId'>;

export const validationSchema: SchemaOf<Fields> = object().shape({
  purchaseOrderId: string()
    .required(REQUIRED_FIELD)
});